import { nextTrackState, playerPlaylistState } from "@/context/states";
import Typography from "@mui/material/Typography";
import { useRecoilState } from "recoil";
import { PlaylistSmallSong } from "./PlaylistSmallSong";

export const PlaylistSmall = ({ songs }) => {
  const [nextTrack, setNextTrack] = useRecoilState(nextTrackState);
  const [playerPlaylist, setPlayerPlaylist] =
    useRecoilState(playerPlaylistState);

  const handlePlaySong = (song) => {
    setPlayerPlaylist(songs);
    setNextTrack(song);
  };

  return (
    <>
      <Typography variant="h4">Songs</Typography>
      {songs
        .filter((s) => s.soundcloud_link !== null)
        .map((song) => {
          return (
            <PlaylistSmallSong
              onPlaySong={handlePlaySong}
              song={song}
              key={song.id}
            ></PlaylistSmallSong>
          );
        })}
    </>
  );
};
